import cookie from 'js-cookie';

export const getUserIdFromCookies = () => Number(cookie.get('userid'));
